import { MAP_AUTH_FAILED_CLASS } from "../utilities/constants";

/**
 * Lazy loads the google maps script
 */
async function mapInit() {
    window.googleMapInit = function () {
        $(document).trigger("googlemap:initialized");
    };
    if (!window.google) {
        var gmapUrl = $(".gmap-source").data("gmap-url");
        try {
            await $.getScript(gmapUrl, function () {});
        } catch (error) {
            console.log("Error fetching Google Maps script: ", error);
        }
    } else {
        window.googleMapInit();
    }

    window.gm_authFailure = function () {
        $(".js-coverage-area-error, .address-form-error-postal-code, .ct-register-corm--postalcode-error, .store-marker").addClass(MAP_AUTH_FAILED_CLASS);
    };
}

module.exports.mapInit = mapInit;
